import React from 'react'
import Cookies from 'js-cookie'
function removeAuth() {
    Cookies.remove('c_user')
}
export function logout() {
    removeAuth()
    window.location.reload()
}